import React from "react";

import { Theme, css } from "@emotion/react";

import { List } from "@mui/material";

import styled from "@emotion/styled";

import { SystemData } from "globalTypes";

import { NavItem } from "./sidebarItems";
import SidebarNavSection from "./SidebarNavSection";

import "vendor/perfect-scrollbar.css";

const baseScrollbar = (props: { theme: Theme }) => css`
  background-color: ${props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ScrollContainer = styled.div`
  ${baseScrollbar}
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

type SidebarNavProps = {
  items: NavItem[];
  systemData: SystemData;
  isCollapsed?: boolean;
};

const SidebarNav: React.FC<SidebarNavProps> = ({
  items,
  systemData,
  isCollapsed = false,
}) => {
  return (
    <ScrollContainer>
      <List disablePadding>
        <Items>
          {items?.map((item) => (
            <SidebarNavSection
              component="div"
              key={item.title}
              pages={item.pages}
              title={item.title}
              type={item.type}
              systemData={systemData}
              isCollapsed={isCollapsed}
            />
          ))}
        </Items>
      </List>
    </ScrollContainer>
  );
};

export default SidebarNav;
